export default "__VITE_ASSET__CabPdLUS__"